import React from 'react';
import { IndexRoute, Route, Redirect, browserHistory } from 'react-router';
import {
  _isUserinfoLoaded as isUserinfoLoaded,
  _fetchProfileEventsInfo as fetchProfileEventsInfo,
} from '../src/pages/Accounts/createAccount/actions';
import {
  isEventDetailsLoaded,
  loadEventDetails,
} from '../src/components/EventDetails/actions';
import commonUtil from '../src/utils/commonUtil';

import * as defaultConst from '../src//utils/clientConstant';
import {
  App,
  GiftRegistryNewAddress,
  SelectWhichMesa,
  EventStatusHandler,
  SelectTypeCelebration,
  SelectTypeEvent,
  SelectMesaType,
  MaxEvents,
  SearchEvent,
  giftTableList,
  MesaHomePage,
  GiftListGuestView,
  GiftList,
  DetailedNotifications,
  CreateEventStrategyLoader,
  CreateCoOWnerAccount,
  SelectWhichMesaTableChoice,
  EventsMaxLimitReached,
  EventManagement,
  Benefits,
  AccountStatus,
  ElectronicsGift,
  PartialTransference,
  PartialConfirmation,
  ClosureTransference,
  ClosureConfirmation,
  PhysicalGifts,
  BonusDetailPage,
  AccountPartialTransfer,
  PersonalPurchases,
  Downloadstatement,
  PrintWindow,
  ErrorPage404,
  Healthcheck,
  Instancecheck,
  Yahoo,
  DeleteCache,
  FlushCache,
  FAQPage,
  RedirectHandlerEventCreate,
} from './pages';
import ProtectedRoutesGroup from './components/ProtectedRoute/ProtectedRoutesGroup';

const { applicationRoutes } = require('./utils/config/applicationRoutesConfig');

// eslint-disable-next-line react/display-name
export default (store) => {
  global.profileID = '';

  /**
   * Please keep routes in alphabetical order
   */
  return (
    <div>
      <Route path='/' component={App} history={browserHistory}>
        {/* Home (main) route */}
        <IndexRoute component={MesaHomePage} />
        {/* Routes requiring login */}
        <Route component={ProtectedRoutesGroup(store)}>
          <Route path={applicationRoutes.giftList} exact component={GiftList} />
          <Route path={applicationRoutes.myEvent} component={EventManagement} />
          <Route
            path={applicationRoutes.eventManagement}
            component={EventManagement}
          />
          {/* Account Partial and Closure */}
          <Route
            path={applicationRoutes.accountStatus}
            component={AccountStatus}
          />
          <Route
            path={applicationRoutes.electronicsGift}
            component={ElectronicsGift}
          />
          <Route
            path={applicationRoutes.physicalGifts}
            component={PhysicalGifts}
          />
          <Route
            path={applicationRoutes.personalPurchases}
            component={PersonalPurchases}
          />
          <Route
            path={applicationRoutes.bonusDetails}
            component={BonusDetailPage}
          />
          <Route
            path={applicationRoutes.accountsPartialTransfer}
            component={AccountPartialTransfer}
          />
          <Route
            path={applicationRoutes.partialTransference}
            component={PartialTransference}
          />
          <Route
            path={applicationRoutes.partialConfirmation}
            component={PartialConfirmation}
          />
          <Route
            path={applicationRoutes.closureTransference}
            component={ClosureTransference}
          />
          <Route
            path={applicationRoutes.closureConfirmation}
            component={ClosureConfirmation}
          />
          {/* END Account Partial and Closure */}
        </Route>

        {/* Routes */}
        {/* AccountPages
        <Route path={applicationRoutes.createAccount} component={<Navigate to='/' />} /> */}
        <Route
          path={applicationRoutes.createCoOwnerAccount}
          component={CreateCoOWnerAccount}
        />
        <Route
          path={applicationRoutes.register}
          component={CreateCoOWnerAccount}
        />
        <Route
          path={applicationRoutes.eventStatusSuspendedForTime}
          component={EventStatusHandler}
        />

        {/* // ! Review functionality */}
        {/* <Route path={applicationRoutes.variantmesa} component={VariasMesas} /> */}

        {/* CREATE EVENT FLOW */}
        <Redirect
          from={applicationRoutes.createEvent}
          to={applicationRoutes.mesaType}
        />
        <Route path={applicationRoutes.maxEvents} component={MaxEvents} />

        <Route path={applicationRoutes.mesaType} component={RedirectHandlerEventCreate} />

        <Route path={applicationRoutes.openType} component={SelectTypeEvent} />
        <Route
          path={applicationRoutes.celebrationType}
          component={SelectTypeCelebration}
        />

        <Route
          path={applicationRoutes.createWedding}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createBaby}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createReligious}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createXVYears}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createFarewell}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createBirthday}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createAniversary}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createFirst_communion}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createBaptisms}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createConfirmations}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createBar_Mitzvah}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createBat_Mitzvah}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createMeetings}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createChildrensParty}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createOtras}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createMascotas}
          component={CreateEventStrategyLoader}
        />
        <Route
          path={applicationRoutes.createOpenHouse}
          component={CreateEventStrategyLoader}
        />

        <Route
          path={applicationRoutes.addDeliveryAddress}
          component={GiftRegistryNewAddress}
        />

        {/* // ! Review functionality */}
        <Route
          path={applicationRoutes.eventsMaxLimitReached}
          component={EventsMaxLimitReached}
        />
        <Route
          path={applicationRoutes.selectWhichMesa}
          component={SelectWhichMesa}
        />
        {/* <Route path='createEvent/ConMesaDesktop' component={ConMesaDesktop} />
        <Route path='createEvent/VariasMesas' component={VariasMesas} />
        <Route path='createEvent/VariasMesas2' component={VariasMesas2} /> */}
        <Route path={applicationRoutes.benefits} component={Benefits} />

        {/* Browse and navigate */}
        <Route
          path={applicationRoutes.selectWhichMesaTableChoice}
          component={SelectWhichMesaTableChoice}
        />

        <Route path={applicationRoutes.searchEvent} component={SearchEvent} />
        <Route
          path={applicationRoutes.giftTableList}
          component={giftTableList}
        />

        {/* eventManagement */}
        {/* .......EventData......... */}
        <Route
          path={applicationRoutes.notificationDetails}
          component={DetailedNotifications}
        />
        {/* .......GiftList......... */}
        <Route
          path={applicationRoutes.giftListGuestView}
          component={GiftListGuestView}
        />
        {/* <Route path='/auth/yahoo' component={Yahoo} /> */}
        <Route path='/auth/yahoo/callback' component={Yahoo} />
        <Route path={applicationRoutes.printData} component={PrintWindow} />
        <Route
          path={applicationRoutes.downloadstatement}
          component={Downloadstatement}
        />

        <Route path={applicationRoutes.FAQPage} component={FAQPage} />
      </Route>

      <Route path={applicationRoutes.healthcheck} component={Healthcheck} />
      <Route path={applicationRoutes.instancecheck} component={Instancecheck} />

      <Route path={applicationRoutes.DeleteCache} component={DeleteCache} />
      <Route path={applicationRoutes.FlushCache} component={FlushCache} />
      {/* Catch all route */}
      <Route path='*' component={ErrorPage404} status={404} />
    </div>
  );
};
